"use strict";

exports.__esModule = true;
exports.ForgotPasswordRoutes = ForgotPasswordRoutes;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _ForgotPasswordScreen = require("./ForgotPasswordScreen");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ForgotPasswordRoutes() {
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: "/forgot-password",
    element: /*#__PURE__*/_react["default"].createElement(_ForgotPasswordScreen.ForgotPasswordScreen, null)
  }));
}